import { Link } from 'react-router';
import { useInstance } from '../core/contexts/InstanceContext';

export default function PublicWelcome() {
    const instance = useInstance();
    return (
        <div className="min-h-screen bg-white flex items-center justify-center p-6">
            <div className="max-w-sm w-full text-center space-y-10">
                <img src="/api/instance/assets/logo" alt={instance.name.short} className="h-10 mx-auto" />
                <div className="space-y-3">
                    <h1 className="text-xl font-black tracking-tight text-slate-900">
                        Willkommen
                    </h1>
                    <p className="text-sm text-slate-500 leading-relaxed">
                        Öffentliche Programme erreichst du über den geteilten Link.
                    </p>
                </div>
                <Link
                    to="/login"
                    className="inline-block w-full py-4 rounded-2xl bg-slate-900 text-white font-bold text-xs uppercase tracking-[0.2em] shadow-lg hover:bg-primary transition-colors"
                >
                    Mitarbeiter-Login
                </Link>
            </div>
        </div>
    );
}
